import { PwaThemePropertyModel } from './pwa.theme.property.model';
import { PwaThemePropertyTypeEnum } from '../enums/pwa-theme-property-type-enum';

export class PwaTheme {
	properties: PwaThemePropertyModel[];

	constructor() {
		this.properties = [
			{
				name: 'primaryColor',
				label: 'theme_primary_color',
				description: 'theme_description_primary_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#000000',
			},
			{
				name: 'secondaryColor',
				label: 'theme_secondary_color',
				description: 'theme_description_secondary_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#6B7280',
			},
			{
				name: 'backgroundColor',
				label: 'theme_background_color',
				description: 'theme_description_background_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#FFFFFF',
			},
			{
				name: 'accentColor',
				label: 'theme_accent_color',
				description: 'theme_description_accent_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#000000',
			},
			{
				name: 'actionColor',
				label: 'theme_action_color',
				description: 'theme_description_action_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#0032ff',
			},
			{
				name: 'successColor',
				label: 'theme_success_color',
				description: 'theme_description_success_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#16A34A',
			},
			{
				name: 'warningColor',
				label: 'theme_warning_color',
				description: 'theme_description_warning_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#F59E0B',
			},
			{
				name: 'dangerColor',
				label: 'theme_danger_color',
				description: 'theme_description_danger_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#F8285A',
			},
			{
				name: 'logoCoverColor',
				label: 'theme_logo_cover_color',
				description: 'theme_description_logo_cover_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#000000',
			},
			{
				name: 'primaryFontColor',
				label: 'theme_primary_font_color',
				description: 'theme_description_primary_font_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#000000',
			},
			{
				name: 'secondaryFontColor',
				label: 'theme_secondary_font_color',
				description: 'theme_description_secondary_font_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#6B7280',
			},
			{
				name: 'btnActionColor',
				label: 'theme_btn_action_color',
				description: 'theme_description_btn_action_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#000000',
			},
			{
				name: 'btnFontActionColor',
				label: 'theme_btn_font_action_color',
				description: 'theme_description_btn_font_action_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#FFFFFF',
			},
			{
				name: 'highlightFontColor',
				label: 'theme_highlight_font_color',
				description: 'theme_description_highlight_font_color',
				type: PwaThemePropertyTypeEnum.COLOR,
				value: '#FFFFFF',
			},
		];
	}
}
